import React from 'react';

import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';

const createReactClass = require('create-react-class');

const UgcSortDropdown = createReactClass({
  getInitialState() {
    return {
      selectedSort: this.props.selectedSort
    };
  },
  componentWillReceiveProps(props) {
    if (props.selectedSort && this.state.selectedSort != props.selectedSort) {
      this.setState({ selectedSort: props.selectedSort });
    }
  },
  handleSortClick(event) {
    const newSort = event.target.value;
    this.setState({ selectedSort: newSort });
    this.props.setUgcLoading();
    this.props.sortTrailData({ sort_option: newSort });
    return true;
  },
  renderSortLinks() {
    return this.props.enabledSortLinks.map((sortKey, i) => {
      return (
        <option key={i} value={sortKey}>
          {StringConstantsMixin.strings.SORT[sortKey]}
        </option>
      );
    });
  },
  render() {
    return (
      <div className={`${StringConstantsMixin.constants.XLATE.NONE} sort-holder input optional`}>
        <div className="dropdown standard-selector dropdown-arrow">
          <div className="standard-select-prefix-wrapper">
            <div className="standard-select-prefix">{StringConstantsMixin.strings.FILTERS.SORT}:</div>
          </div>
          <select onChange={this.handleSortClick} className="standard-select" value={this.state.selectedSort}>
            {this.renderSortLinks()}
          </select>
        </div>
      </div>
    );
  }
});

UgcSortDropdown.defaultProps = {
  enabledSortLinks: ['atSort', 'desc', 'asc', 'highestRated', 'lowestRated'],
  selectedSort: ''
};

export { UgcSortDropdown };
